export default __webpack_public_path__ + "df2406dd8bb954a349fe51acd4e3ea40.png";